import React, { useState, useEffect } from "react";

const words = [
    { word: "REACT", hint: "Libreria JavaScript" },
    { word: "PYTHON", hint: "Linguaggio serpente" },
    { word: "SERVER", hint: "Computer che fornisce servizi" },
    { word: "CODING", hint: "Scrivere programmi" },
    { word: "PIXEL", hint: "Unità base delle immagini" },
    { word: "GITHUB", hint: "Piattaforma per sviluppatori" },
    { word: "CLOUD", hint: "Archiviazione online" },
    { word: "ARRAY", hint: "Struttura dati ordinata" },
    { word: "FUNCTION", hint: "Blocco di codice riutilizzabile" },
    { word: "VARIABLE", hint: "Contenitore di dati" },
    { word: "BROWSER", hint: "Navigatore web" },
    { word: "DATABASE", hint: "Archivio di dati strutturati" }
];

export default function WordShuffle() {
    const [usedWords, setUsedWords] = useState([]);
    const [currentWord, setCurrentWord] = useState(null);
    const [shuffled, setShuffled] = useState("");
    const [answer, setAnswer] = useState("");
    const [score, setScore] = useState(0);
    const [attempts, setAttempts] = useState(0);
    const [feedback, setFeedback] = useState("");
    const [gameActive, setGameActive] = useState(false);

    const shuffleWord = (word) => {
        let shuffled = word.split("");
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled.join("");
    };

    const generateQuestion = () => {
        // Filtra le parole già usate
        const availableWords = words.filter(w => !usedWords.includes(w.word));

        // Se non ci sono più parole disponibili, termina il gioco
        if (availableWords.length === 0) {
            setGameActive(false);
            return;
        }

        const word = availableWords[Math.floor(Math.random() * availableWords.length)];
        let shuffledWord = shuffleWord(word.word);

        // Assicura che non sia uguale alla parola originale
        let attempts = 0;
        while (shuffledWord === word.word && word.word.length > 2 && attempts < 10) {
            shuffledWord = shuffleWord(word.word);
            attempts++;
        }

        setCurrentWord(word);
        setShuffled(shuffledWord);
        setAnswer("");
        setFeedback("");

        // Aggiungi la parola alla lista di quelle usate
        setUsedWords([...usedWords, word.word]);
    };

    const startGame = () => {
        setScore(0);
        setAttempts(0);
        setGameActive(true);
        setUsedWords([]);
        generateQuestion();
    };

    const checkAnswer = () => {
        if (answer.toUpperCase() === currentWord.word) {
            setScore(score + 1);
            setFeedback("✓ Corretto!");
            setAttempts(attempts + 1);
            setTimeout(() => {
                if (attempts + 1 < 5) {
                    generateQuestion();
                } else {
                    setGameActive(false);
                }
            }, 1000);
        } else {
            setFeedback("✗ Riprova!");
            setTimeout(() => setFeedback(""), 1000);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && answer && gameActive) {
            checkAnswer();
        }
    };

    const skipWord = () => {
        setAttempts(attempts + 1);
        if (attempts + 1 < 5) {
            generateQuestion();
        } else {
            setGameActive(false);
        }
    };

    if (!gameActive && attempts === 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-random" style={{marginRight:"6px"}}></i> Word Shuffle
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Riordina le lettere per formare parole tech!</p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (!gameActive && attempts > 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    {score}/5 parole
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score === 5 && "🎉 Perfetto! Maestro delle parole!"}
                    {score >= 3 && score < 5 && "👍 Ottimo risultato!"}
                    {score < 3 && "💪 Continua a esercitarti!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{marginBottom:"1rem", color:"#94a3b8", fontSize:"0.85rem"}}>
                Parola {attempts + 1} di 5 - Punteggio: {score}
            </div>

            {currentWord && (
                <>
                    <div style={{
                        padding:"0.6rem",
                        background:"rgba(59,130,246,0.1)",
                        borderRadius:"0.5rem",
                        marginBottom:"1.5rem",
                        fontSize:"0.8rem",
                        color:"#94a3b8"
                    }}>
                        <i className="fas fa-lightbulb" style={{marginRight:"6px", color:"#facc15"}}></i>
                        {currentWord.hint}
                    </div>

                    <div style={{
                        fontSize:"2.5rem",
                        fontWeight:"700",
                        letterSpacing:"0.5rem",
                        marginBottom:"1.5rem",
                        color:"#00ffa3",
                        fontFamily:"monospace"
                    }}>
                        {shuffled}
                    </div>

                    <input
                        type="text"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value.toUpperCase())}
                        onKeyPress={handleKeyPress}
                        autoFocus
                        maxLength={currentWord.word.length}
                        style={{
                            width:"100%",
                            padding:"0.8rem",
                            borderRadius:"0.5rem",
                            border:"2px solid rgba(255,255,255,0.1)",
                            background:"rgba(255,255,255,0.05)",
                            color:"#fff",
                            fontSize:"1.2rem",
                            textAlign:"center",
                            outline:"none",
                            marginBottom:"1rem",
                            letterSpacing:"0.3rem",
                            fontFamily:"monospace"
                        }}
                        placeholder="SCRIVI QUI..."
                    />

                    {feedback && (
                        <div style={{
                            padding:"0.6rem",
                            background: feedback.includes("✓") ? "rgba(34,197,94,0.2)" : "rgba(239,68,68,0.2)",
                            borderRadius:"0.5rem",
                            marginBottom:"1rem",
                            fontSize:"0.9rem",
                            color: feedback.includes("✓") ? "#22c55e" : "#ef4444",
                            fontWeight:"600"
                        }}>
                            {feedback}
                        </div>
                    )}

                    <div style={{display:"flex", gap:"0.5rem"}}>
                        <button
                            onClick={checkAnswer}
                            disabled={!answer}
                            style={{
                                flex:1,
                                background: answer ? "linear-gradient(135deg,#2563eb,#1e40af)" : "rgba(255,255,255,0.1)",
                                border:"none",
                                color:"#fff",
                                fontWeight:"700",
                                padding:"0.6rem 1.2rem",
                                borderRadius:"0.5rem",
                                cursor: answer ? "pointer" : "not-allowed",
                                opacity: answer ? 1 : 0.5
                            }}
                        >
                            <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica
                        </button>
                        <button
                            onClick={skipWord}
                            style={{
                                background:"rgba(239,68,68,0.2)",
                                border:"1px solid rgba(239,68,68,0.3)",
                                color:"#ef4444",
                                fontWeight:"700",
                                padding:"0.6rem 1.2rem",
                                borderRadius:"0.5rem",
                                cursor:"pointer"
                            }}
                        >
                            <i className="fas fa-forward" style={{marginRight:"6px"}}></i> Salta
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}